import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useForm, Controller } from "react-hook-form";
import {
    Modal,
    Box,
    Grid,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Backdrop,
    CircularProgress,
    Button,
} from "@mui/material";

// import CancelPresentationIconButton from "../../../commonComponent/Buttons/CancelPresentationIconButton";
// import CommonButton from "../../../commonComponent/Buttons/CommonButton";
// import ConfirmationModal from "../../../commonComponent/ConfirmationModal";
// import CommonDynamicTablePagination from "../../../commonComponent/CommonTable/CommonMasterPaginationTable";
// import DatePickerField from "../../../commonComponent/FormFields/DatePickerField";
// import TimePickerField from "../../../commonComponent/FormFields/TimePickerField";
// import SearchDropdown from "../../../commonComponent/FormFields/searchDropdown";
// import InputField from "../../../commonComponent/FormFields/InputField";
// import {
//     successAlert,
//     errorAlert,
//     updateAlert,
// } from "../../../commonComponent/Toasts/CustomToasts";
import { postDoctorDropdown,postOperativeNotessaveOrUpdate, postBloodGroupDropdown, getDoctorTypeDropDown, preOperativeNotessaveOrUpdate, postgetAntibioticsDropdown } from "../../../services/otDetailsServices/OtDetailsServices";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import InputField from "../../../../common/components/FormFields/InputField";
import TimePickerFieldNew from "../../../../common/components/FormFields/TimePickerFieldNew";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import { errorAlert, successAlert } from "../../../../common/components/Toasts/CustomToasts";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import DropdownField from "../../../../common/components/FormFields/DropdownField";

const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "90vh",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "1px solid gray",
    borderRadius: 2,
    boxShadow: 20,
    p: 3,
};

export default function PostOperativeNotesModel(props) {

    const [openPost, setOpenPost] = useState(false);
    const [pendingData, setPendingData] = useState(null);
    const [dataResult, setDataResult] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [patientData, setPatientData] = useState({});
    const [surgeonOptions, setSurgeonOptions] = useState([]);
    const [anesthetistOptions, setAnesthetistOptions] = useState([]);
    const [bloodGroupOptions, setBloodGroupOptions] = useState([]);
    const [checkedByOptions, setCheckedByOptions] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);


    const defaultValues = {
        patientReceivedTime: null,
        surgery: "",
        surgeon: null,
        anaesthesia: null,
        ivOnFlow: "",
        infusion: "",
        skinIssue: "",
        drain: "NA",
        foleys: "NA",
        rt: "NA",
        remark: "",
        irrigation: "",
        nbmOutTime: null,
        postOpInvestigations: "",
        bloodProducts: "",
        checkedBy: null,
        bloodGroup: null,
        bagNo: "",
        collectionDate: null,
        expiryDate: null,
        startTime: null,
        endTime: null,
        bloodRemark: "",
    };

    const {
        control,
        handleSubmit,
        reset,
        setValue,
    } = useForm({
        defaultValues,
    });

    const handleOpenPost = () => {
        setOpenPost(true);
    };
    const handleClosePost = () => {
        setOpenPost(false);
    };

    const getSurgeonDropdown = async (value = "") => {
        console.log("API Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);
            setSurgeonOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getAnesthetistDropdown = async (value = "") => {
        console.log("Anesthetist Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setAnesthetistOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getBloodGroupDropdown = async () => {
        try {
            const response = await postBloodGroupDropdown("");

            console.log(
                "Blood Group API:",
                response.data.result
            );

            setBloodGroupOptions(
                response?.data?.result || []
            );
        } catch (error) {
            console.log(error);
        }
    };

    const getCheckedByDropdown = async (value = "") => {
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);
            setCheckedByOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const handleSubmitClick = (data) => {
        setPendingData(data);
        setOpenPost(true);
    };


    const getTimePayload = (time) => {
        if (!time) return null;

        const timeObj = new Date(time);

        return `${String(timeObj.getHours()).padStart(2, "0")}:${String(
            timeObj.getMinutes()
        ).padStart(2, "0")}:${String(timeObj.getSeconds()).padStart(2, "0")}`;
    };

    const addRecord = async () => {
        try {
            setLoading(true);

            const data = pendingData;

            const payload = {
                id: isUpdate ? props.patientData?.id : null,

                admissionId: props?.admissionId || 0,
                otHeaderId: props?.otHeaderId || 0,

                patientReceivedTime: getTimePayload(
                    data?.patientReceivedTime
                ),
                surgery: data?.surgery || "",
                surgeonId: data?.surgeon?.id || 0,
                anesthesiaDoctorId:
                    data?.anaesthesia?.id || 0,
                ivOnFlow: data?.ivOnFlow || "",
                infusion: data?.infusion || "",
                skinIssue: data?.skinIssue || "",
                drain: data?.drain || "",
                foleys: data?.foleys || "",
                rt: data?.rt || "",
                tubingRemark: data?.remark || "",
                irrigation: data?.irrigation || "",
                nbmOutTime: getTimePayload(
                    data?.nbmOutTime
                ),
                postOpInvestigations:
                    data?.postOpInvestigations || "",
                bloodProducts:
                    data?.bloodProducts || "",
                checkedById:
                    data?.checkedBy?.id || 0,
                bloodGroup:
                    data?.bloodGroup?.label ||
                    data?.bloodGroup ||
                    "",

                bagNo: data?.bagNo || "",

                collectionDate: data?.collectionDate
                    ? dayjs(data.collectionDate).format(
                        "YYYY-MM-DD"
                    )
                    : null,

                expiryDate: data?.expiryDate
                    ? dayjs(data.expiryDate).format(
                        "YYYY-MM-DD"
                    )
                    : null,

                startTime: getTimePayload(
                    data?.startTime
                ),

                endTime: getTimePayload(
                    data?.endTime
                ),

                bloodProductRemark:
                    data?.bloodRemark || "",

                ...(isUpdate
                    ? {
                        updatedBy: 1,
                        updatedDateTime: new Date().toISOString(),
                    }
                    : {
                        addedBy: 1,
                        addedDateTime: new Date().toISOString(),
                        updatedBy: 1,
                        updatedDateTime: new Date().toISOString(),
                    }),

            };

            console.log(
                "POST OPERATIVE PAYLOAD",
                payload
            );

            const response =
                await postOperativeNotessaveOrUpdate(
                    payload
                );

            successAlert(
                response?.data?.message ||
                "Saved Successfully"
            );

            reset(defaultValues);

            handleClosePost();
            // props.handleClose();
        } catch (error) {
            errorAlert(
                error?.response?.data?.message ||
                "Something went wrong"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (props.patientData) {
            setPatientData(props.patientData);
        }
    }, [props.patientData]);

    useEffect(() => {
        if (props.patientData?.id > 0) {

            setIsUpdate(true);

            reset({
                patientReceivedTime:
                    props.patientData?.patientReceivedTime
                        ? new Date(
                            `2000-01-01T${props.patientData.patientReceivedTime}`
                        )
                        : null,

                surgery: props.patientData?.surgery || "",

                surgeon:
                    props.patientData?.surgeonId
                        ? {
                            id: props.patientData.surgeonId,
                            label: props.patientData.surgeonName,
                            value: props.patientData.surgeonName,
                        }
                        : null,

                anaesthesia:
                    props.patientData?.anesthesiaDoctorId
                        ? {
                            id: props.patientData.anesthesiaDoctorId,
                            label:
                                props.patientData.anesthesiaDoctorName,
                            value:
                                props.patientData.anesthesiaDoctorName,
                        }
                        : null,

                ivOnFlow:
                    props.patientData?.ivOnFlow || "",

                infusion:
                    props.patientData?.infusion || "",

                skinIssue:
                    props.patientData?.skinIssue || "",

                drain:
                    props.patientData?.drain || "NA",

                foleys:
                    props.patientData?.foleys || "NA",

                rt:
                    props.patientData?.rt || "NA",

                remark:
                    props.patientData?.tubingRemark || "",

                irrigation:
                    props.patientData?.irrigation || "",

                nbmOutTime:
                    props.patientData?.nbmOutTime
                        ? new Date(
                            `2000-01-01T${props.patientData.nbmOutTime}`
                        )
                        : null,

                postOpInvestigations:
                    props.patientData?.postOpInvestigations || "",

                bloodProducts:
                    props.patientData?.bloodProducts || "",

                checkedBy:
                    props.patientData?.checkedById
                        ? {
                            id: props.patientData.checkedById,
                            label:
                                props.patientData.checkedByName,
                            value:
                                props.patientData.checkedByName,
                        }
                        : null,

                bloodGroup: null,

                bagNo:
                    props.patientData?.bagNo || "",

                collectionDate:
                    props.patientData?.collectionDate
                        ? new Date(
                            props.patientData.collectionDate
                        )
                        : null,

                expiryDate:
                    props.patientData?.expiryDate
                        ? new Date(
                            props.patientData.expiryDate
                        )
                        : null,

                startTime:
                    props.patientData?.startTime
                        ? new Date(
                            `2000-01-01T${props.patientData.startTime}`
                        )
                        : null,
                endTime:
                    props.patientData?.endTime
                        ? new Date(
                            `2000-01-01T${props.patientData.endTime}`
                        )
                        : null,

                bloodRemark:
                    props.patientData?.bloodProductRemark || "",
            });

        } else {
            setIsUpdate(false);
            reset(defaultValues);
        }
    }, [props.patientData]);

    useEffect(() => {
        getBloodGroupDropdown();
    }, []);

    useEffect(() => {
        if (
            props.patientData?.bloodGroup &&
            bloodGroupOptions.length > 0
        ) {
            const selectedBloodGroup =
                bloodGroupOptions.find(
                    item =>
                        item.label ===
                        props.patientData.bloodGroup
                );

            if (selectedBloodGroup) {
                setValue(
                    "bloodGroup",
                    selectedBloodGroup
                );
            }
        }
    }, [
        props.patientData?.bloodGroup,
        bloodGroupOptions,
        setValue,
    ]);

    return (
        <div>
            <Box
                sx={{
                    mt: 2,
                    p: 3,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    backgroundColor: "#fff",
                }}
            >

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                    <div className="border rounded-md bg-white">
                        <div className="bg-[#adfde8] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Surgery Details
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Patient Received Time
                                </Typography>
                                <Typography>:</Typography>

                                <TimePickerFieldNew
                                    control={control}
                                    name="patientReceivedTime"
                                    label="Patient Received Time"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Surgery</Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="surgery"
                                    label="Surgery"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Surgeon</Typography>
                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="surgeon"
                                    label="Surgeon"
                                    placeholder="Surgeon"
                                    options={surgeonOptions || []}
                                    dataArray={surgeonOptions || []}
                                    searchIcon
                                    isClearable
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) =>
                                        getSurgeonDropdown?.(value)
                                    }
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Anaesthesia</Typography>
                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="anaesthesia"
                                    label="Anaesthesia"
                                    placeholder="Anaesthesia"
                                    options={anesthetistOptions || []}
                                    dataArray={anesthetistOptions || []}
                                    searchIcon
                                    isClearable
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) =>
                                        getAnesthetistDropdown?.(value)
                                    }
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">IV On Flow</Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="ivOnFlow"
                                    label="IV On Flow"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Infusion</Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="infusion"
                                    label="Infusion"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Skin Issue</Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="skinIssue"
                                    label="Skin Issue"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>

                    <div className="border rounded-md bg-white h-full">
                        <div className="bg-[#ffd6d6] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Blood Products
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Blood Products
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="bloodProducts"
                                    label="Blood Products"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Checked By
                                </Typography>

                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="checkedBy"
                                    label="Checked By"
                                    placeholder="Checked By"
                                    options={checkedByOptions}
                                    dataArray={checkedByOptions}
                                    searchIcon={true}
                                    isClearable={true}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        getCheckedByDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Blood Group
                                </Typography>

                                <Typography>:</Typography>

                                <DropdownField
                                    control={control}
                                    name="bloodGroup"
                                    placeholder="Select Blood Group"
                                    label="Blood Group"
                                    options={bloodGroupOptions}
                                    dataArray={bloodGroupOptions}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Bag No
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="bagNo"
                                    label="Bag No"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Collection Date
                                </Typography>

                                <Typography>:</Typography>

                                <DatePickerField
                                    control={control}
                                    name="collectionDate"
                                    label="Collection Date"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                inputFormat={"dd-MM-yyyy"}
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Expiry Date
                                </Typography>

                                <Typography>:</Typography>

                                <DatePickerField
                                    control={control}
                                    name="expiryDate"
                                    label="Expiry Date"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                                                    inputFormat={"dd-MM-yyyy"}

                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Start Time
                                </Typography>

                                <Typography>:</Typography>

                                <TimePickerFieldNew
                                    control={control}
                                    name="startTime"
                                    label="Start Time"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    End Time
                                </Typography>

                                <Typography>:</Typography>

                                <TimePickerFieldNew
                                    control={control}
                                    name="endTime"
                                    label="End Time"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-start gap-1">
                                <Typography fontWeight="600">
                                    Remark
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="bloodRemark"
                                    label="Remark"
                                    multiline
                                    rows={4}
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#ebfead] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Tubing & Linings
                        </div>

                        <div className="space-y-3 px-3 py-2">


                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Drain</Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="drain"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel
                                                value="YES"
                                                control={<Radio size="small" />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value="NO"
                                                control={<Radio size="small" />}
                                                label="No"
                                            />
                                            <FormControlLabel
                                                value="NA"
                                                control={<Radio size="small" />}
                                                label="NA"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </div>

                            {/* Foleys */}
                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Foleys</Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="foleys"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel
                                                value="YES"
                                                control={<Radio size="small" />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value="NO"
                                                control={<Radio size="small" />}
                                                label="No"
                                            />
                                            <FormControlLabel
                                                value="NA"
                                                control={<Radio size="small" />}
                                                label="NA"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </div>

                            {/* RT */}
                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">RT</Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="rt"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel
                                                value="YES"
                                                control={<Radio size="small" />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value="NO"
                                                control={<Radio size="small" />}
                                                label="No"
                                            />
                                            <FormControlLabel
                                                value="NA"
                                                control={<Radio size="small" />}
                                                label="NA"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </div>

                            {/* Remark */}
                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Remark</Typography>
                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="remark"
                                    label="Remark"
                                    multiline
                                    rows={3}
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>

                    <div className="space-y-4">
                        <div className="border rounded-md bg-white">
                            <div className="bg-[#cfe8ff] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                                Recovery Details
                            </div>


                            <div className="space-y-2 px-3 py-2">

                                <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                    <Typography fontWeight="600">
                                        Irrigation
                                    </Typography>

                                    <Typography>:</Typography>

                                    <InputField
                                        control={control}
                                        name="irrigation"
                                        label="Irrigation"
                                        size="small"
                                        fullWidth
                                    />
                                </div>

                                <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                    <Typography fontWeight="600">
                                        NBM Out Time
                                    </Typography>

                                    <Typography>:</Typography>

                                    <TimePickerFieldNew
                                        control={control}
                                        name="nbmOutTime"
                                        label="NBM Out Time"
                                        textFieldProps={{
                                            size: "small",
                                            fullWidth: true,
                                        }}
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="border rounded-md bg-white">
                            <div className="bg-[#ffe5c7] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                                Post OP Investigations
                            </div>
                            <div className="space-y-2 px-3 py-2">

                                <div className="grid grid-cols-[220px_20px_1fr] items-start gap-1">
                                    <Typography fontWeight="600">
                                        Post OP Investigations
                                    </Typography>

                                    <Typography>:</Typography>

                                    <InputField
                                        control={control}
                                        name="postOpInvestigations"
                                        label="Post OP Investigations"
                                        multiline
                                        rows={4}
                                        fullWidth
                                    />
                                </div>

                            </div>
                        </div>
                    </div>



                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => reset()}
                        sx={{
                            textTransform: "none",
                        }}
                    >
                        Reset
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSubmit(handleSubmitClick)}
                        sx={{
                            backgroundColor: "#22c55e",
                            color: "#fff",
                            textTransform: "none",
                            fontWeight: 500,
                            px: 2,
                        }}
                    >
                        {isUpdate ? "Update" : "Submit"}
                    </Button>
                </div>

            </Box>


            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 9999,
                }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ConfirmationModal
                confirmationOpen={openPost}
                confirmationHandleClose={handleClosePost}
                confirmationSubmitFunc={addRecord}
                confirmationLabel="Confirmation"
                confirmationMsg="Are you sure you want to submit this record ?"
                confirmationButtonMsg="Confirm"
            />
        </div >
    );
}